<template>
  <v-container no-gutters :class="['pa-1', 'note-' + type]">
    <v-row no-gutters>
      <v-col cols="auto">
        <v-icon left>{{ icon }}</v-icon>
      </v-col>
      <v-col>
        <span>
          {{ message }}
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NoteWidget",
  components: {},
  props: {
    type: {
      type: String,
      default: "info",
    },
    message: {
      type: String,
      required: true,
    },
  },
  computed: {
    icon: function () {
      switch (this.type) {
        case 'warning':
          return "mdi-alert"
        case 'success':
          return "mdi-check"
        case 'error':
          return "mdi-bug"
      }
      return "mdi-information-outline";
    },
  },
};
</script>

<style scoped>
.note-info {
  background-color: var(--v-info-base) !important;
}
.note-success {
  background-color: var(--v-success-base) !important;
}
.note-warning {
  background-color: var(--v-warning-base) !important;
}
.note-error {
  background-color: var(--v-error-base) !important;
}
</style>